import UnsuccessfulSearch from './UnsuccessfulSearch';

export default UnsuccessfulSearch;
